import { Stack, Typography } from "@mui/material";

import BroadcastingTabsComponent from "../../components/panel/broadcasting.tsx/Broadcasting";

export default function BroadCastingPage() {
  return (
    <>
      <Stack
        width="100%"
        direction="column"
        justifyContent="start"
        alignItems="start"
        px={{ xs: "8px", md: "20px" }}
        gap="10px"
      >
        <Stack direction={"column"} width="100%">
          <Stack
            direction={{ xs: "column", md: "row" }}
            justifyContent="space-between"
            alignItems={{ md: "center", xs: "start" }}
            width="100%"
          >
            <Stack>
              <Typography
                variant="h4DemiBold"
                color={({ palette }) => palette.dominant.main}
                sx={{
                  mb: "4px",
                  mt: { xs: "0px", sm: "24px" },
                }}
              >
                پیام صوتی
              </Typography>
              <Typography
                variant="footerDemiBold"
                color={({ palette }) => palette.complement[300]}
                sx={{
                  mb: "20px",
                }}
              >
                لیست پیام صوتی
              </Typography>
            </Stack>
          </Stack>
          <BroadcastingTabsComponent />
        </Stack>
      </Stack>
    </>
  );
}
